module.exports = __webpack_public_path__ + "img/clock-rotate-left.7542dded.svg";